import generic from "./generic.js";
import generic2 from "./generic2.js";
import schmidt from "./schmidt.js";

/**
 * Brand (skin) registry. The active brand is selected at BUILD time via the
 * `VITE_BRAND` env var (baked into the frontend image per customer — see
 * ops/deploy/fe.env.tpl and disploy.sh). Defaults to the generic brand.
 *
 * A new customer skin = add a `./<brand>.js` config (+ its logo asset) and set
 * `VITE_BRAND=<brand>` in that deployment's env. No component code changes.
 *
 * A brand config supports:
 *   id, name, productName
 *   footer: { productName, companyName }
 *   palette: { primary: {seed, anchor, overrides?}, secondary: {…} }
 *   sidebar: { background }
 *   assets: { logo, logoAlt, background?, favicon? }
 *   features: { showSidebarTitle, help, userDisplay, claimWizardFlow, nav: {…} }
 *              // claimWizardFlow: "broker" (single-phase journey) | "customer" (two-phase)
 *   contact: { label, name, funktion, telefon, fax, email }   // Kontakt modal
 *   labels:  { tenantName, short }                            // inline labels
 *   typography?: { fontFamily?, headingFamily?, bodyFamily? } // defaults to Inter
 *   auth?:   { badge, headline (string|string[]), subtext }   // login copy
 * Optional sections fall back to sensible defaults, so older skins keep working.
 */
const brands = {
  generic,
  // Vendor-neutral clone of `schmidt` (names only) — see generic2.js.
  generic2,
  schmidt,
};

const requested = import.meta.env.VITE_BRAND;

export const activeBrand = brands[requested] ?? brands.generic;

export default activeBrand;
